import loadable from "@loadable/component"
import { useLocation } from "react-router-dom"

import IntersectionWrapper from "components/common/intersection-wrapper"
import { retry } from "helpers/application"

const FooterBottom = loadable(() => retry(() => import("./footer-bottom")), {
  ssr: false,
})
const FooterContent = loadable(() => retry(() => import("./footer-content")), {
  ssr: false,
})
const FooterSubscribe = loadable(
  () => retry(() => import("./footer-subscribe")),
  { ssr: false }
)

const FooterMain = () => {
  const location = useLocation()

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments")
  ) {
    return ""
  }

  return (
    <IntersectionWrapper id="footer-wrapper">
      <FooterSubscribe />
      <footer className="bg-black-print widescreen:py-60 py-32">
        <FooterContent />
        <FooterBottom />
      </footer>
    </IntersectionWrapper>
  )
}

export default FooterMain
